import React from "react"
import { Field, Form } from "react-final-form"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { ResetPasswordFormFieldNames } from "./types"
import { useSubmitHandler } from "./useSubmitHandler"
import { FormTitle } from "../../components/FormTitle"
import { GoBack } from "../../components/GoBack"
import { StyledLoginForm } from "../../components/StyledLoginForm"
import { SubmitButton } from "../../components/SubmitButton"
import { TextFieldLogon } from "../../components/TextFieldLogon"
import { FormHeader } from "../../containers/FormHeader"

export const ResetPasswordForm = ({ executeOnSuccess }) => {
  const { i18n } = useTranslations()
  const { handleSubmit, submitting, error } = useSubmitHandler(executeOnSuccess)

  return <Form onSubmit={handleSubmit}
               render={({ handleSubmit, values }) => <StyledLoginForm
                 onSubmit={handleSubmit}>
                   <FormHeader sx={{ marginBottom: "10px" }}>
                     <GoBack />
                     <FormTitle>{i18n("Account.ForgottenPassword:FormTitle")}</FormTitle>
                   </FormHeader>

                   <Field name={ResetPasswordFormFieldNames.username}
                          validate={(value) => !value?.trim() ? i18n("Validation:FieldRequired") : undefined}>
                     {({ input, meta }) => <TextFieldLogon
                       {...input}
                       disabled={submitting}
                       autoComplete="off"
                       id={LOGIN_INPUT_ID}
                       label={i18n("Login:Username")}
                       error={!!error || (meta.touched && !!meta.error)}
                       inputProps={{
                         "aria-labelledby": LOGIN_INPUT_ID
                       }}
                       helperText={(meta.touched && meta.error) || (!!error && i18n("Author.Login:CantResetPassword"))}
                       width="auto"
                       placeholder={i18n("Login:Username")}
                     />}
                   </Field>
                   <SubmitButton label={i18n("Account.ForgottenPassword:SendEmail")}
                                 type="submit" disabled={submitting}
                                 isLoading={submitting} />
               </StyledLoginForm>} />
}

const LOGIN_INPUT_ID = "login-input-id"
